import './AddSpecialist.css';

const TestForm = () => {
  return (
    <div className="add-specialist-container">
      <h2>Добавить специалиста или организацию</h2>
      
      <div className="intro-text">
        <p>
          Если вы специалист в какой-то области, что-то делаете, учите, готовите, 
          предоставляете какие-либо услуги и хотите, чтобы ваша карточка была создана на сайте, 
          то подготовьте следующую информацию:
        </p>
      </div>

      <div className="requirements-section">
        <h3>Необходимая информация:</h3>
        <ul className="requirements-list">
          <li><strong>ФИО или название организации</strong></li>
          <li><strong>Контакты, которые вы хотите указать:</strong>
            <ul>
              <li>WhatsApp</li>
              <li>Telegram</li>
              <li>Сайт</li>
              <li>Instagram</li>
              <li>Другие соцсети</li>
            </ul>
          </li>
          <li><strong>Описание вас и/или ваших услуг</strong></li>
          <li><strong>От 1 до 3 квадратных (!) фото</strong></li>
          <li><strong>Опционально:</strong> прайс-лист или информация о ценах</li>
        </ul>
      </div>

      <div className="process-section">
        <h3>Как добавиться:</h3>
        <div className="process-steps">
          <div className="step">
            <span className="step-number">1</span>
            <p>Подготовьте всю необходимую информацию</p>
          </div>
          <div className="step">
            <span className="step-number">2</span>
            <p>Направьте все материалы в <a href="https://t.me/Olga_Makey" target="_blank" rel="noopener noreferrer">Telegram</a></p>
          </div>
          <div className="step">
            <span className="step-number">3</span>
            <p>В течение 5 дней ваша карточка будет создана</p>
          </div>
        </div>
      </div>

      <div className="contact-section">
        <p>
          <a href="https://t.me/Olga_Makey" target="_blank" rel="noopener noreferrer" className="telegram-link">
            Связаться с нами
          </a>
        </p>
        <p className="note">
          <strong>Примечание:</strong> Размещение карточки на сайте бесплатное. 
          Мы стараемся поддерживать русскоязычное сообщество во Флорипе!
        </p>
      </div>
    </div>
  );
};

export default TestForm;